import { Star } from "lucide-react";

export default function Stars({ value = 5, size = 16, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} sur 5`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const fill = Math.max(0, Math.min(1, value - i));
        return (
          <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
            <Star className="absolute inset-0 text-amber-500/25" style={{ width: size, height: size }} />
            <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
              <Star className="text-amber-400 fill-amber-400" style={{ width: size, height: size }} />
            </span>
          </span>
        );
      })}
    </div>
  );
}
